import globals from '../../utils/globals'

const ENDPOINT = {
  staging: {
    'eu-west-1': 'https://yb6d4q9u3f.execute-api.eu-west-1.amazonaws.com/v1/event'
  },
  production: {
    'eu-west-1': 'https://o9tt6h08li.execute-api.eu-west-1.amazonaws.com/v1/event',
    'us-west-2': 'https://t3t09eztsd.execute-api.us-west-2.amazonaws.com/v1/event'
  },
  development: {
    'eu-west-1': 'https://yb6d4q9u3f.execute-api.eu-west-1.amazonaws.com/v1/event'
  },
  local: {
    'eu-west-1': 'https://yb6d4q9u3f.execute-api.eu-west-1.amazonaws.com/v1/event'
  }
}

function trackEvent (eventName, eventPayload, cb) {
  const environment = globals('environment')
  const region = globals('region')
  const communityId = globals('communityId')
  const http = new window.XMLHttpRequest()

  if (eventPayload.type === 'Topic Clicked' || eventPayload.type === 'Category Clicked') return

  if (!environment || !region || !communityId) {
    return cb && cb(null)
  }

  http.open('POST', ENDPOINT[environment][region], true)
  http.withCredentials = true
  if (cb) {
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        if (http.status >= 200 && http.status < 400) {
          return cb(null)
        }
        return cb(new Error(http.responseText))
      }
    }
  }
  const payload = JSON.stringify(Object.assign(
    {},
    eventPayload,
    { eventName, communityId }
  ))
  http.send(payload)
}

export default { trackEvent }
